import MailingFilesStelaModalView from "./mailingFilesStelaModal.html";
import SearchPersonsModalView from '../notifications/searchPersonsModal.html';

angular.module("mailings")

    .controller("MailingsEditCtrl", ['mailingId', 'entityType', 'entityTypeId', '$rootScope', '$scope', '$uibModal', '$uibModalInstance', '$timeout', '$http', '$stateParams', 'Restangular', 'Upload', '$state', 'modalService', '$filter', 'gridService', 'generateDocumentService', 'BeeService', 'logService', '$q', 'LoginService',
        function (mailingId, entityType, entityTypeId, $rootScope, $scope, $uibModal, $uibModalInstance, $timeout, $http, $stateParams, Restangular, Upload, $state, modalService, $filter, gridService, generateDocumentService, BeeService, logService, $q, LoginService) {

            $rootScope.title = $filter('translate')('mailing.title');
            $scope.mailingId = null;
            $scope.showDocuments = false;
            $scope.loadBee = true;

            $scope.mailingId = mailingId;
            $scope.entity_type = entityType;
            $scope.entity_type_id = entityTypeId;
            $scope.mailingsTypes = [];
            $scope.mailing = [];
            $scope.mailing.filesToShow = [];
            $scope.mailing.attachments = [];
            $scope.mailing.documentsIds = [];

            if (entityType == 'events') {
                $scope.forEvents = true;
            } else {
                $scope.forEvents = false;
            }

            let loadMailingsTypes = function () {
                Restangular.all('MailingsTypes').getList().then(function (types) {

                    $scope.allMailingsTypes = types;
                    $scope.mailingsTypes = types.filter(function (t) { return !t.is_system; });

                    if ($scope.forEvents) {
                        $scope.mailing.mailing_type_id = $scope.mailingsTypes.filter(function (config) { return config.code == "EVENTS"; }).map(function (config) { return config.id; })[0];
                    }

                });

            }

            let languageCode = "es"; //$translate.use().toLowerCase();
            $scope.tinymceOptions = {
                resize: true,
                contextmenu: false,
                branding: false,
                forced_root_block: false,
                relative_urls: false,
                convert_urls: false,
                remove_script_host: false,
                height: 100,
                body_class: 'custom_tinymce_content',
                //valid_classes: 'razor_expression',
                language: languageCode,
                paste_as_text: true,
                plugins: 'paste autoresize textcolor image lists advlist table noneditable code link fullpage',
                toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link | code",
                menubar: false,
                statusbar: false
            };

            Restangular.all('NotificationsTemplates').customGET("LoadTemplatesForSelect").then(function (templates) {
                $scope.templates = templates;
            });

            let loadMailsAccounts = function () {

                if ($scope.forEvents) {
                    Restangular.one('Events', $scope.entity_type_id).get().then(function (event) {
                        Restangular.all('MailAccounts').getList().then(function (accounts) {
                            if (typeof ($scope.mailingId) == 'undefined')
                                $scope.mailing.mail_account_id = event.mail_account_id;

                            // En caso de que no haya una defininda para el evento, utilizamos la cuenta por defecto, si la hay.
                            let defaultAccount = accounts.filter(m => m.use_by_default)[0];
                            $scope.mailing.cco = event.bcc;
                            if (typeof ($scope.mailingId) == 'undefined' && defaultAccount != null && $scope.mailing.mail_account_id == null) $scope.mailing.mail_account_id = defaultAccount.id;

                            $scope.mailsAccounts = accounts;
                        });
                    });
                } else {
                    Restangular.all('MailAccounts').getList().then(function (mailsAccounts) {
                        $scope.mailsAccounts = mailsAccounts;
                        // Si no es  para eventos, utilizamos por defecto la cuenta definida como tal.
                        let defaultAccount = mailsAccounts.filter(m => m.use_by_default)[0];
                        if (typeof ($scope.mailingId) == 'undefined' && defaultAccount != null && $scope.mailing.mail_account_id == null) $scope.mailing.mail_account_id = defaultAccount.id;
                    });
                }
                

            };

            loadMailingsTypes();

            Restangular.one('Mailings', $scope.mailingId).get().then(function (result) {
                $scope.mailing = result;

                $scope.mailing.filesToShow = [];
                $scope.mailing.attachments = [];
                $scope.mailing.documentsIds = [];
                
                if (typeof ($scope.mailingId) != 'undefined') {
                    if ($scope.mailing.preheader == null) {
                        $scope.mailing.preheader = "[EVENT_NAME] [EVENT_DATE]";
                    }

                    if ($scope.mailing.json != null && $scope.mailing.json !== "") {
                        $scope.loadBee = true;
                        BeeService.reload(JSON.parse($scope.mailing.json));
                    } else {
                        $scope.loadBee = false;
                    }

                    if (result.id != null) {
                        if (result.FK_mailing_attachment_mailing.length > 0) {
                            angular.forEach(result.FK_mailing_attachment_mailing, function (row) {
                                $scope.mailing.filesToShow.push(row);
                            });
                        }
                    }

                    loadMailsAccounts()

                } else {
                    loadMailsAccounts();
                    $scope.loadBee = true;
                    BeeService.start({});
                    $scope.mailing.ics = 0;
                    $scope.mailing.icon = "glyphicon glyphicon-asterisk";
                    $scope.mailing.is_blocked = true;
                }
            });

            if ($scope.entity_type == 'events') {
                $scope.for_event_guest = true;
            }

            var optionsValues = {
                entity_type: $scope.entity_type,
                entity_type_id: $scope.entity_type_id,
                codes: $scope.codes,
                for_event_guest: $scope.for_event_guest,
                for_event_staff: $scope.for_event_staff,
                for_event_workteam: $scope.for_event_workteam,
                for_correspondence: $scope.for_correspondence
            };
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentsType',
                params: optionsValues
            }).then(function (results, status, headers, config) {
                $scope.documents = results.data.rows;

                $scope.documentsTypes = $scope.documents.map(function (item) { return { code: item.FK_documents_documents_types.code, name: item.FK_documents_documents_types.name } }).filter(function (x, i, a) {
                    return a.findIndex(m => m.code === x.code) == i;
                });
            });


            $scope.loadTemplate = function (template_id) {
                if (typeof (template_id) !== "undefined" && template_id !== null && template_id !== "") {
                    Restangular.one('Templates', template_id).get().then(function (result) {
                        let json = result.FK_templates_tl_templates.filter(function (tl) { return tl.language_id == $rootScope.languageId })[0].json;
                        if (json != null && json !== "") {
                            $scope.loadBee = true;
                            BeeService.reload(JSON.parse(json));
                        } else if (json == null || json === "") {
                            $scope.loadBee = false;
                            $scope.mailing.content = result.FK_templates_tl_templates.filter(function (tl) { return tl.language_id == $rootScope.languageId })[0].html;
                        }
                    });
                } else {
                    $scope.mailing.content = "";
                }
            }

            $scope.openSearchPerson = function (whereToAdd) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchPersonsModalView,
                    size: "lg",
                    controller: "searchPersonsModalCtrl",
                    scope: $scope,
                    resolve: {
                        options: function () {
                            return {};
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    let mailsSelected = "";
                    angular.forEach(data, function (row) {
                        mailsSelected = (mailsSelected != "" ? mailsSelected + "," + row : row);
                    });
                    if (whereToAdd == "addresses") {
                        $scope.mailing.addresses = (typeof ($scope.mailing.addresses) !== 'undefined' && $scope.mailing.addresses != "" ? $scope.mailing.addresses + "," + mailsSelected : mailsSelected);
                    } else if (whereToAdd == "cc_tmp") {
                        $scope.mailing.cc_tmp = (typeof ($scope.mailing.cc_tmp) !== 'undefined' && $scope.mailing.cc_tmp != "" ? $scope.mailing.cc_tmp + "," + mailsSelected : mailsSelected);
                    } else if (whereToAdd == "cco_tmp") {
                        $scope.mailing.cco = (typeof ($scope.mailing.cco) !== 'undefined' && $scope.mailing.cco != "" ? $scope.mailing.cco + "," + mailsSelected : mailsSelected);
                    }
                    if (!$scope.$$phase) $scope.$apply();
                }, function () {
                    if (!$scope.$$phase) $scope.$apply();
                });
            };

            $scope.newAttachment = function (file) {
                if (file != null) {
                    Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "mailings" }).then(function (result) {
                        if (result.filter(e => e.type === file.type).length <= 0) {
                            var typeAllowed = result.map(o => o.type).join(', ');
                            modalService.message({
                                title: "Error",
                                message: "File: "+file.type+"<br><br>"+$filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                onAccept: function () { }
                            });
                        } else {
                            var maxSizeAllowed = result.find(e => e.type === file.type).maxsize;
                            var sizeFileMB = file.size / 1024;
                            if (sizeFileMB > 0) {
                                //Comprobamos que no pase del tamaño limite de imagen
                                if (sizeFileMB > maxSizeAllowed) {
                                    modalService.message({
                                        title: "Error",
                                        message: "File: " + sizeFileMB.toFixed(2) + "<br><br>" + $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                        onAccept: function () { }
                                    });
                                } else {
                                    $scope.mailing.filesToShow.unshift(file);
                                    Upload.base64DataUrl(file).then(function (urls) {
                                        $scope.mailing.attachments.push({
                                            name: file.name,
                                            content: urls
                                        });
                                    });                            
                                }
                            }
                        }
                    })
                }
            };

            $scope.newAttachmentStela = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: MailingFilesStelaModalView,
                    size: "lg",
                    controller: "MailingFilesStelaModalCtrl",
                    scope: $scope,
                    resolve: {
                        entity_type: function () { return $scope.entity_type != null ? $scope.entity_type :"general" },
                        entity_type_id: function () { return $scope.entity_type_id != null?$scope.entity_type_id:null; },
                        is_public: function () { return false; },
                        folderId: function () { return null; }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    if (data.length > 0) {
                        angular.forEach(data, function (row) {
                            $scope.mailing.filesToShow.push({
                                name: row.filename,
                                type: row.mimetype
                            });
                            $scope.mailing.attachments.push({
                                name: row.filename,
                                file_id: row.id,
                                mimetype: row.mimetype,
                                uid: row.uid
                            })
                        })
                    }

                }, function () {

                });

            };


            $scope.deleteAttachment = function (item) {
                let index = $scope.mailing.filesToShow.indexOf(item);
                $scope.mailing.filesToShow.splice(index, 1);
                let option = {
                    id: item.id
                };

                if (!angular.isUndefined(option.id)) {
                    Restangular.all('Mailings/DeleteAttachment').remove(option).then(function (result) {
                    });
                } else {
                    if ($scope.mailing.documentsIds.length > 0) {
                        var idx = $scope.mailing.documentsIds.find(function (row, i) {
                            if (row.document_name === item.name) {
                                return i;
                            }
                        });
                        $scope.mailing.documentsIds.splice(idx, 1);
                    }
                }
            };
            
            $scope.saveMailing = function () {
                if (typeof ($scope.mailingId) == "undefined") {
                    $scope.mailing.entity_type = $scope.entity_type;
                    $scope.mailing.entity_type_id = $scope.entity_type_id;

                    /*if ($scope.forEvents) {
                        $scope.mailing.mail_account_id = null;
                    }*/
                    Restangular.all('Mailings').post($scope.mailing).then(function (result) {
                        $scope.mailing.id = result.id;
                        $scope.uploadAttachment($scope.mailing);
                        $uibModalInstance.close();
                    });
                } else {
                    if (!$scope.loadBee) {
                        $scope.mailing.json = null;
                    }
                    $scope.mailing.put().then(function (result) {
                        if ($scope.mailing.filesToShow.length == 0 && $scope.mailing.FK_mailing_attachment_mailing.length > 0) {
                            //Eliminamos todos los adjuntos de la comunicacion
                            Restangular.all('Mailings/DeleteAllAttachments').remove({ mailingId: $scope.mailing.id }).then(function (result) { });

                        } else {
                            if ($scope.mailing.filesToShow.length > 0) {
                                $scope.uploadAttachment($scope.mailing);
                            }
                        }
                        
                        toastr.success($filter('translate')('general.edit_success'));
                        $uibModalInstance.close();
                    });
                }
            };

            $scope.save = function () {
                if($scope.loadBee) {
                    BeeService.save().then(function (result) {
                        $scope.mailing.json = result.json;
                        $scope.mailing.content = result.html;
                        $scope.saveMailing();
                    });
                } else {
                    $scope.saveMailing();
                }
            }

            $scope.uploadAttachment = function (mailing) {
                $http({
                    method: 'post',
                    url: (window as any).CONFIG.api_url + 'Mailings/UploadAttachment',
                    data: mailing
                }).then(function (results) {
                    $scope.mailing.attachments = [];
                })
            }

            $scope.openDocumentsModal = function (document_code) {
                if (document_code != null && document_code != "") {
                    var params = {
                        entity_type: $scope.entity_type,
                        entity_type_id: $scope.entity_type_id,
                        documents: { codes: [document_code] }
                    };
                    generateDocumentService.documentNew({
                        params: params,
                        onAccept: function (data) {

                            // se lo añadimos a los files....

                            var doc = { name: data[0].document_name }
                            $scope.mailing.filesToShow.unshift(doc);
                            $scope.mailing.documentsIds.unshift({ document_id: data[0].document_id, document_name: data[0].document_name, document_type: data[0].document_type_code})
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('general.delete'),
                    message: $filter('translate')('general.delete_message') + " " + $scope.mailing.subject + "?",
                    onAccept: function () {
                        $scope.mailing.remove().then(function () {
                            toastr.success($filter('translate')('general.deleted_success'));
                            $uibModalInstance.close();
                        });
                    }
                });
            };        

            $scope.showOrNotMailAccounts = function (type) {
                if (type.code == "EVENTS") {
                    $scope.showMailsAccounts = false;
                } else {
                    $scope.showMailsAccounts = true;
                }
            }

            $scope.callbackClose = function (mode) {
                $uibModalInstance.dismiss(mode);
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.canManageEntityAcl = function (acl) {
                return LoginService.aclEnabled() && LoginService.permissionExist("ACL_MANAGE") && LoginService.userCanManageAcl(acl);
            };
            $scope.aclUsers = [];
            $scope.aclGroups = [];
            $scope.aclOptionsLoaded = false;
            $scope.aclDialogState = { visible: false, savedVersion: 0 };

            let normalizeAclUser = function (user) {
                const name = user.name || user.username || ('User #' + user.id);
                const username = user.username || '';
                const words = name.trim().split(/\s+/);
                const initials = (words.length >= 2 ? words[0][0] + words[words.length - 1][0] : name.slice(0, 2)).toUpperCase();
                return { id: user.id, label: name, initials: initials, sub: (username && username !== name) ? username : (user.email || '') };
            };

            let normalizeAclGroup = function (group) {
                const name = group.name || ('Group #' + group.id);
                return { id: group.id, label: name, initials: name.slice(0, 2).toUpperCase(), sub: group.members_count ? (group.members_count + ' miembros') : '' };
            };

            $scope.loadAclOptions = function () {
                if ($scope.aclOptionsLoaded) return $q.when();
                return $q.all([
                    Restangular.all('Users').getList(),
                    Restangular.all('UsersGroups').getList()
                ]).then(function (results) {
                    $scope.aclUsers = (results[0] || []).map(normalizeAclUser);
                    $scope.aclGroups = (results[1] || []).map(normalizeAclGroup);
                    $scope.aclOptionsLoaded = true;
                });
            };

            $scope.openAclDialog = function () {
                $scope.loadAclOptions().then(function () {
                    $scope.aclDialogState.visible = true;
                });
            };

            $scope.$watch('aclDialogState.savedVersion', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    $scope.mailing.put().then(function (result) {
                        if (typeof result.id !== 'undefined') {
                            toastr.success($filter('translate')('mailing.acl_save_success'));
                        }
                    });
                }
            });
    }]);